import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { lighten } from '@mui/material/styles';

export const HolidayPillKey: React.FC = () => {
  const exampleColor = '#444';

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        mt: 1, 
        bgcolor: 'rgba(0,0,0,0.02)',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    >

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
        {/* Standard */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 80,
              height: 24,
              borderRadius: '16px',
              background: exampleColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '0.7rem',
            }}
          >
            Standard
          </Box>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            Full day holiday
          </Typography>
        </Box>

        {/* Part Day */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 80,
              height: 24,
              borderRadius: '16px',
              background: `repeating-linear-gradient(
                45deg,
                ${exampleColor},
                ${exampleColor} 4px,
                ${lighten(exampleColor, 0.15)} 4px,
                ${lighten(exampleColor, 0.15)} 8px
              )`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '0.7rem',
            }}
          >
            Part Day
          </Box>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            Part day holiday
          </Typography>
        </Box>

        {/* Special Conditions */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 80,
              height: 24,
              borderRadius: '16px',
              background: `radial-gradient(circle at 25% 25%, ${lighten(exampleColor, 0.2)} 2px, transparent 2px),
                          radial-gradient(circle at 75% 75%, ${lighten(exampleColor, 0.2)} 2px, transparent 2px),
                          ${exampleColor}`,
              backgroundSize: '8px 8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '0.7rem',
            }}
          >
            Special
          </Box>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            Special conditions apply
          </Typography>
        </Box>

        {/* Source Count */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 80,
              height: 24,
              borderRadius: '16px',
              background: exampleColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 1,
              color: 'white',
              fontSize: '0.7rem',
            }}
          >
            <span>Holiday</span>
            <Box
              sx={{
                px: 0.5,
                py: 0.25,
                bgcolor: 'rgba(0,0,0,0.2)',
                borderRadius: '4px',
                fontSize: '0.65rem',
                fontWeight: 600,
                minWidth: '18px',
                textAlign: 'center',
              }}
            >
              3
            </Box>
          </Box>
          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
            Number = source count
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};
